

exports.__esModule = true;

var _angular = require('angular');

var _uiRouter = require('uiRouter');

var _squid = require('squid');

var _checkout = require('xo-models/src/checkout');

var _fi = require('xo-models/src/fi');

var _app = require('xo-models/src/app');

var _auth = require('xo-models/src/auth');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoTopupFundingDirective', {
    tag: 'xo-topup-funding',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        success: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            var checkoutCart = _checkout.$CheckoutCartModel.instance(this.props.token);
            var auth = _auth.$AuthModel.instance();

            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                walletPreferences: _fi.$WalletPreferences.instance(this.props.token).retrieve(),
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(this.props.token).retrieve(),
                tokenizedFundingCapabilitiesModel: _app.$TokenizedFundingCapabilitiesModel.instance(this.props.token).retrieve({
                    params: {
                        tokenizedWalletToken: checkoutCart.tokenizedWalletToken,
                        country: auth.country
                    }
                })
            };
        }
    },

    actions: {
        selectFundingSource: function selectFundingSource(id) {
            var _models = this.models,
                checkoutSession = _models.checkoutSession,
                walletPreferences = _models.walletPreferences,
                tokenizedFundingCapabilitiesModel = _models.tokenizedFundingCapabilitiesModel;


            if (walletPreferences.getPreferred().instrument_id !== id) {
                if (tokenizedFundingCapabilitiesModel.isTopupEnabled()) {
                    // Extract the matching topup instrument_id for a given id
                    walletPreferences.topup.fundingSource = _squid.$util.find(checkoutSession.topupFundingSources, function (fs) {
                        return fs.instrument_id === id;
                    });
                } else {
                    // Extract the matching direct_funding instrument_id for a given id
                    walletPreferences.direct.fundingSource = _squid.$util.find(checkoutSession.futurePaymentInstruments, function (fs) {
                        return fs.instrument_id === id;
                    });
                }

                // PatchXO api call for tokenization flows when instrument is changed from Wallet page
                this.models.checkoutSession.action('setTopupFI', {
                    data: {
                        instrument_id: id
                    }
                });
            }
            this.props.success();
        },
        addCard: function addCard() {
            _uiRouter.$state.go('.sidepageAddCard.addCardFlow.addCard');
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.locale = _squid.$locale;
            this.addCardCallbacks = {
                finish: function finish() {
                    if (_this.models.checkoutSession.selectedTopupFundingSource) {
                        _this.models.walletPreferences.topup.fundingSource = _this.models.checkoutSession.selectedTopupFundingSource;
                    }
                    $('#sidepageAddCard').removeClass('sidepageAddCardOpen');
                    (0, _angular.$timeout)(function () {
                        return _uiRouter.$state.go('checkout.review');
                    }, 300);
                },
                cancel: function cancel() {
                    $('#sidepageAddCard').removeClass('sidepageAddCardOpen');
                    (0, _angular.$timeout)(function () {
                        return _uiRouter.$state.go('^.^.^');
                    }, 300);
                }
            };

            this.instrumentIconId = function (name) {
                return _fi.$WalletInstrumentNameMapping.instance().getInstrumentNameNormalized(name);
            };

            /**
             * Get the list of funding sources to display in the wallet page
             */
            this.fundingSourcesList = function () {
                var _models2 = this.models,
                    tokenizedFundingCapabilitiesModel = _models2.tokenizedFundingCapabilitiesModel,
                    checkoutSession = _models2.checkoutSession;
                var topupFundingSources = checkoutSession.topupFundingSources,
                    futurePaymentInstruments = checkoutSession.futurePaymentInstruments;


                if (tokenizedFundingCapabilitiesModel.isTopupEnabled()) {
                    return topupFundingSources;
                } else {
                    // Filter only the Bank accounts for direct funding
                    return futurePaymentInstruments.filter(function (instrument) {
                        return instrument.type === 'BANK';
                    });
                }
            };
        },

        populate: function populate() {
            $('#topupFundingList').css('height', function () {
                return window.innerHeight || document.documentElement && document.documentElement.clientHeight;
            });
        }
    }
});


_angular.$timeout;

_uiRouter.$state;

_squid.$Component;

_squid.$locale;

_squid.$util;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutCartModel;

_fi.$WalletPreferences;

_fi.$WalletInstrumentNameMapping;

_app.$TokenizedWalletInfoModel;

_app.$TokenizedFundingCapabilitiesModel;

_auth.$AuthModel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/topup/topup-funding/directive.js
// module id = ../node_modules/xo-wallet-components/src/topup/topup-funding/directive.js
// module chunks = 0